module.exports = __webpack_public_path__ + "static/media/icon-surgery.fdbdf0f7.svg";